import 'dotenv/config';
import React from "react";
import ReactDOM from "react-dom";
import App from "./app";
import "antd/dist/antd.css";
import "../styles/css/styles.scss";
import './utils/axios.js';
// import './i18n'; // 引入 i18n 配置
ReactDOM.render( <App />, document.getElementById("app"));
import 'babel-polyfill'
